exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-class[data-v-663b4a47] {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.select-with[data-v-663b4a47] {\n    width: 28%;\n}\n.button-width[data-v-663b4a47] {\n    width: 16%;\n    float: right;\n}\ndiv#table[data-v-663b4a47] {\n    white-space: nowrap;\n}\n", ""]);

// exports
